var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4H4.17071C4.58254 5.16519 5.69378 6 7 6H11C12.3062 6 13.4175 5.16519 13.8293 4H15C15.5523 4 16 4.44772 16 5V21C16 21.5523 15.5523 22 15 22H3C2.44772 22 2 21.5523 2 21V5C2 4.44772 2.44772 4 3 4ZM15 2H13.8293C13.4175 0.834808 12.3062 0 11 0H7C5.69378 0 4.58254 0.834808 4.17071 2H3C1.34315 2 0 3.34315 0 5V21C0 22.6569 1.34315 24 3 24H15C16.6569 24 18 22.6569 18 21V5C18 3.34315 16.6569 2 15 2ZM7 2C6.44772 2 6 2.44772 6 3C6 3.55228 6.44772 4 7 4H11C11.5523 4 12 3.55228 12 3C12 2.44772 11.5523 2 11 2H7ZM5 13C4.44772 13 4 13.4477 4 14C4 14.5523 4.44772 15 5 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H5ZM4 10C4 9.44771 4.44772 9 5 9H13C13.5523 9 14 9.44771 14 10C14 10.5523 13.5523 11 13 11H5C4.44772 11 4 10.5523 4 10ZM5 17C4.44772 17 4 17.4477 4 18C4 18.5523 4.44772 19 5 19H13C13.5523 19 14 18.5523 14 18C14 17.4477 13.5523 17 13 17H5Z",
    fill: "#9296AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderGray);
export default __webpack_public_path__ + "static/media/orderGray.df862bfc4c85d8550b2d0b31034d4002.svg";
export { ForwardRef as ReactComponent };